export default {
  methods: {
    $getSeoHead(key, country = '', gameName = '') {
      const { $i18n } = this
      const titleKey = `seo.${key}.title`
      const descKey = `seo.${key}.description`
      const result = {
        meta: [],
        __dangerouslyDisableSanitizersByTagID: {
          description: ['content'],
        },
        link: [
          {
            rel: 'canonical',
            href: `https://www.toplupe.com/${country}/${gameName}`,
          },
        ],
        // __dangerouslyDisableSanitizers: ['meta'],
      }
      const title = $i18n.te(titleKey) ? $i18n.t(titleKey) : ''
      const description = $i18n.te(descKey) ? $i18n.t(descKey) : ''

      if (title && title !== titleKey) {
        result.title = title
      }

      if (description && description !== descKey) {
        result.meta.push({
          hid: 'description',
          name: 'description',
          content: description,
        })
      }

      return result
    },
  },
}
